module.exports = __webpack_public_path__ + "static/media/sms-otp-authenticator-logo.6dc1c4ee.png";